"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProps = void 0;
var utils_1 = require("../utils");
var imgix_1 = require("../imgix");
var media_1 = require("../../../../theme/media");
var buildSrcSet = function (path, width, options, density) {
    if (density === void 0) { density = 1; }
    return "".concat((0, imgix_1.buildUrl)(path, __assign({ w: width }, options)), " ").concat(density, "x");
};
var getProps = function (config) { return ({
    sources: Object.entries(config)
        .sort(function (_a, _b) {
        var _c = __read(_a, 1), breakpointA = _c[0];
        var _d = __read(_b, 1), breakpointB = _d[0];
        return utils_1.MAX_SIZES[breakpointA] > utils_1.MAX_SIZES[breakpointB] ? -1 : 1;
    })
        .map(function (_a) {
        var _b = __read(_a, 2), breakpoint = _b[0], bpc = _b[1];
        var breakpointFullWidth = utils_1.MAX_SIZES[breakpoint];
        var width = Math.ceil(breakpointFullWidth * (bpc.width / 100));
        return {
            srcSet: "".concat(buildSrcSet(bpc.path, width, bpc.options || {}, 1), ", ").concat(buildSrcSet(bpc.path, width * 2, bpc.options || {}, 2)),
            media: "".concat(media_1.breakpoints[breakpoint]),
        };
    }),
}); };
exports.getProps = getProps;
